import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React from 'react';
import { IconName } from '../images/IconMap';
import Icons from '../images/Icons';
import { MixinAnimationFade } from '../structure/DefaultStyles';
import { BodyMedium, TitleMedium } from '../text/Typography';

interface IPageBannerCardProps {
    as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    title?: string;
    description?: string | React.ReactNode;
    icon?: IconName;
    iconSize?: number;
    fullHeight?: boolean;
    children?: React.ReactNode;
}

export default function PageBannerCard({
    as,
    title,
    description,
    icon,
    iconSize = 100,
    fullHeight = false,
    children,
    ...restProps
}: IPageBannerCardProps) {
    // try to appropriately set the heading level based on the fullHeight prop
    if (fullHeight) {
        as = as || 'h1';
    } else {
        as = as || 'h3';
    }

    return (
        <BannerCard $fullHeight={fullHeight} {...restProps}>
            {icon && <Icons name={icon} size={iconSize} />}
            {title && <TitleMedium as={as}>{title}</TitleMedium>}
            {description && typeof description === 'string' ? <BodyMedium>{description}</BodyMedium> : description}
            {children}
        </BannerCard>
    );
}

const BannerCard = styled.div<{ $fullHeight: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    max-width: 600px;
    text-align: center;
    gap: 10px;
    flex-grow: 1;
    padding: 20px;
    ${({ $fullHeight }) => $fullHeight && FullHeight};
    ${MixinAnimationFade};
`;

const FullHeight = css`
    height: 100%;
`;
